<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div>
      <el-input
        v-model.trim="searchData.Name"
        size="small"
        placeholder="应用程序名称"
        class="w-180px mr-10px"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.Type"
        class="mr-10px"
        clearable
        popper-class="select-popper"
        placeholder="业务类型"
      >
        <el-option
          v-for="(option, index) in businessType"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.IsThirdParty"
        class="mr-10px"
        clearable
        popper-class="select-popper"
        placeholder="是否第三方系统"
      >
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>

      <el-button type="primary" @click="onSubmit">搜索</el-button>
      <el-button type="primary" size="small" @click="reset">重置</el-button>
      <el-button type="primary" @click="add">新增</el-button>
      <el-button @click="multipleRemove(selection)" type="danger" size="small">删除</el-button>
    </div>
    <el-table
      v-loading="loading"
      class="mt-10px"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      @select="selectSingle"
      @select-all="selectAll"
      border
      :stripe="true"
      height="calc(100% - 100px)"
      style="width: 100%"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :show-overflow-tooltip="!item.width"
      >
        <template slot-scope="scope">
          <div>{{ getTabColValue(scope.column.property, scope.row[scope.column.property]) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleView(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="mt-20px mb-20px float-right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import { SingleSignOnApi } from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import dayjs from 'dayjs'

const singleSignOnApi = new SingleSignOnApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  data() {
    return {
      searchData: {
        Name: '',
        IsThirdParty: '',
        Type: '',
      },
      loading: false,
      tableData: [],
      businessType: [],
      selection: [],
      selectCode: 'SingleBusinessType',
      columnList: [
        {
          prop: 'name',
          label: '应用程序名称',
        },
        {
          prop: 'redirectURL',
          label: '应用程序地址',
        },
        {
          prop: 'isThirdParty',
          label: '是否第三方系统',
          width: '140px',
        },
        {
          prop: 'type',
          label: '业务类型',
          width: '120px',
        },
        {
          prop: 'creatorName',
          label: '创建人',
          width: '120px',
        },
        {
          prop: 'creationTime',
          label: '创建时间',
          width: '180px',
        },
      ],
      page: {
        pageNum: 1,
        pageSize: 15,
        total: 100,
      },
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  mounted() {
    this.getBusinessType()
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.tableData = []
      this.loading = true
      const params = {
        name: this.searchData.Name,
        isThirdParty: this.searchData.IsThirdParty,
        type: this.searchData.Type,
      }
      const [err, res] = await singleSignOnApi.getAppssoSettingPage(
        this.page.pageNum,
        this.page.pageSize,
        params
      )
      if (!err && res) {
        this.loading = false
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    async getBusinessType() {
      this.businessType = []
      const [err, res] = await dataCategoryApi.getByCode({
        code: this.selectCode,
        includeDetails: true,
      })
      if (!err) {
        this.businessType = res.dataItems
      }
    },
    getTabColValue(col, value) {
      if (col === 'creationTime') {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      }
      if (col === 'isThirdParty') {
        return value ? '是' : '否'
      }
      return value
    },
    onSubmit() {
      this.page.pageNum = 1
      this.page.pageSize = 15
      this.getTableData()
    },
    reset() {
      this.searchData = this.$options.data().searchData
    },
    add() {
      this.$router.push({
        path: `${this.routerBase}/portal-management/system-management/app-config`,
      })
    },
    handleView(index, row) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/system-management/app-config`,
        query: {
          rowData: row,
          mode: 'view',
        },
      })
    },
    handleEdit(index, row) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/system-management/app-config`,
        query: {
          rowData: row,
          mode: 'edit',
        },
      })
    },
    // 多条数据删除
    multipleRemove(selection) {
      if (!selection.length) {
        this.$message.warning('请先应用程序再操作！')
        return
      }
      const arrIds = _.map(selection, (i) => {
        return i.id
      })
      this.$confirm('此操作将永久删除应用程序，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.selection = []
        const [err, res] = await singleSignOnApi.deleteAppssoSetting({ body: arrIds })
        if (!err) {
          this.$message.success('删除应用程序成功')
          this.getTableData()
        }
      })
    },
    handleDelete(index, row) {
      this.$confirm(`此操作将永久删除${row.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await singleSignOnApi.deleteAppssoSetting({ body: [row.id] })
        if (!err) {
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
          this.getTableData()
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.page.pageNum = 1
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getTableData()
    },
    selectSingle(selection) {
      this.selection = selection
    },
    selectAll(selection) {
      this.selection = selection
    },
  },
}
</script>

<style lang="scss" scoped></style>
